import React from 'react';
import Bounce from 'react-reveal/Bounce';
import { FaICursor } from 'react-icons/fa';

const ProjectStats = ({ title, count, years }) => {
  const totalYears = years.reduce((a, b) => a + b, 0);

  const one = (years[0] / years[4]) * 100;
  const two = (years[1] / years[4]) * 100;
  const three = (years[2] / years[4]) * 100;
  const four = (years[3] / years[4]) * 100;
  const five = (years[4] / years[4]) * 100;

  console.log((count / years[4]) * 100);
  console.log(count);

  return (
    <Bounce left>
      <div className='bar-container'>
        <div className='bar-fill' style={{ width: `${(count / years[4]) * 100}%`, backgroundColor: '#57b33e' }}>
          <span className='count' style={{ left: `${(count / years[4]) * 100}%` }}>
            {count}
          </span>
          <div className='bar-title'>{title}</div>
          <div className='info two'>
            <span>{years[1]}MW</span>
            <FaICursor className='icon' />
            <span>2022</span>
          </div>
          <div className='info five'>
            <span>{years[4]}MW</span>
            <FaICursor className='icon' />
            <span>2025</span>
          </div>
        </div>
      </div>
    </Bounce>
  );
};

export default ProjectStats;
